import { FC } from 'react';
import { FormTextField } from 'components/FormFields/FormTextField';
import { FormSelectField } from 'components/FormFields/FormSelectField';

export const fieldsMap: Record<string, FC<any>> = {
  textField: FormTextField,
  select: FormSelectField,
};